import {inject} from '@angular/core';
import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ConsoleAuthenticationService} from "@security/console-authentication.service";

export const unauthenticatedAccessInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const auth: ConsoleAuthenticationService = inject(ConsoleAuthenticationService);
  return next(req).pipe(catchError(err => {
    //check if current request if for logout - if yes and a 401  occurs, then don't try log out again
    if ([401, 403].includes(err.status) && !req.url.includes('logout') && !req.url.includes('login')) {
      auth.logout();
    }
    const error = err.message || err.statusText;
    console.log(error);
    throw err;
  }));
}

